<template>
  <v-card class="elevation-0 ma-8 px-2 py-6">
    <v-card-title>
        Pacientes
        <v-spacer></v-spacer>
        <v-text-field
            @keydown.enter="getDataFromApi()"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            class="mb-6 mx-4"
        ></v-text-field>
    </v-card-title>
    
    <v-data-table
        @click:row="onRowClick"
        :items="filteredClients" 
        :headers="header"
        :footer-props="{'items-per-page-options':[15, 30, 50, totalClients]}"
        :options.sync="options"
        :server-items-length="totalClients"
        :loading="loading"
    >
    <template v-slot:[`item.profile_photo_path`]="{ item }">
        <v-avatar size="35"><img :src="item.profile_photo_path"/></v-avatar>
    </template>
    <template v-slot:[`item.reciever_phone`]="{ item }">
        <span @click="sendIvitation(item)">{{item.reciever_phone}}</span>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list style="font-size:13px;">
                <v-list-item @click="sendNotification(item.id)">
                    <v-icon small class="mr-2">
                        mdi-email
                    </v-icon>
                    Enviar accesos
                </v-list-item>
                <v-list-item @click="copyClipboard(item.id)">
                    <v-icon small class="mr-2">
                        mdi-link
                    </v-icon>
                    Copiar link de acceso
                </v-list-item>
                <v-list-item @click="edited_item = item, editDialog = true">
                    <v-icon small class="mr-2">
                        mdi-pencil
                    </v-icon>
                    Editar Usuario
                </v-list-item>
            </v-list>
        </v-menu>
    </template>
    </v-data-table>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>

    <!-- Crear paciente -->
    <v-dialog v-model="createDialog" max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn bottom color="#e12826" dark fab fixed right v-bind="attrs" v-on="on">
            <v-icon color="white">  mdi-plus </v-icon>
        </v-btn> 
      </template>
      <create @closeCreateDialog="closeCreateDialog"/>
    </v-dialog>

    <!-- editar paciente -->
    <v-dialog v-model="editDialog" max-width="700px">
      <edit v-bind:user="edited_item" @closeEditDialog="closeEditDialog"/>
    </v-dialog>


  </v-card>
</template>

<script>
import Create from './create.vue'
import Edit from './edit.vue'
import axios from "axios"
  export default {
    components:{
      'create': Create,
      'edit':Edit
    },
    data () {
      return {
        edited_item:{},
        editDialog:false,
        createDialog:false,
        editDialog: false,
        totalClients: 0,
        clients: [],
        loading: true,
        options: {},
        activeSearch: false,
        search: '',
        header: [
            {text:'', value:'profile_photo_path', sortable:false},
            {text:'Nombre', value:'name'},
            {text:'Email', value:'email'},
            { text: 'Edad', value: 'birthdate' },
            { text: 'Estatura', value: 'height' },
            { text: 'Indice de Actividad', value: 'physical_activity_index' },
            {text:'Plan', value:'training_plan'},
            {text:'Última Cita', value:'last_appointment'},
            {text:'Citas', value:'appointments'},
            {text:'Proxima Cita', value:'next_appointment'},
            {value:'actions', sortable:false},
        ],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
      }
    },
    computed:{
        currentUser:{
            get(){
                return this.$store.state.currentUser.user;
            }
        },
        filteredClients(){
            if(this.currentUser.id!=1){
                return this.clients.filter(c=>c.training_plan.includes(this.currentUser.name))
            }else{
                return this.clients
            }
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods:{
        onRowClick(item){
            this.$router.push('/client/' + item.id);
        },
        sendNotification(user_id){
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/user/send_app_invite/'+user_id).then(resp=>{
                this.snackbar = {
                    color:'success',
                    show:true,
                    message:'Acceso enviado con éxito',
                }

            }).catch(error=>{
                this.snackbar = {
                    color:'error',
                    show:true,
                    message:'No se pudo enviar el acceso',
                }
            })
        },
        copyClipboard(user_id){
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/user/send_app_invite/'+user_id+'?copyClipboard=true').then(resp=>{
                navigator.clipboard.writeText(resp.data);
                this.snackbar = {
                    color:'success',
                    show:true,
                    message:'Enlace copiado al portapapeles',
                }

            }).catch(error=>{
                this.snackbar = {
                    color:'error',
                    show:true,
                    message:'No se pudo obtener el enlace',
                }
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.clients = data.clients
                this.totalClients = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var clients = []
                var total = 0
                var link = ''
                if(sortBy.length === 1){
                    if(sortDesc[0]){
                        link = link + "sort=-" + sortBy[0] + '&'
                    }else{
                        link = link + "sort=" + sortBy[0] + '&'
                    }
                }
                if(this.search!=''){
                    link = link + 'filter[name]=' + this.search + '&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage).then(response => {
                    clients = this.mapClients(response.data.data)
                    total = total = response.data.meta.total
                    resolve({
                        clients,
                        total,
                    })
                })
            })
        },
        mapClients(items){
            return items
        },
        closeCreateDialog: function(params){
            this.getDataFromApi()
            this.createDialog = params
        },
        closeEditDialog: function(params){
            this.getDataFromApi()
            this.editDialog = params
        }
    }
}
</script>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>